module.exports = __webpack_public_path__ + "sc.svg?36964dc612396d77c345fd327821f20d";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/sc.svg
// module id = 928
// module chunks = 27